import http from '../../http';

const vRutaTablero = 'tablerocontrol/';
const vHeader = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    }
};

export const getTableroResumen = (sucursal) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_LOADING" });
        var parameters = JSON.stringify({ sucursal });

        http.post(vRutaTablero + 'obtenerresumen.php', parameters, vHeader)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_RESUMEN_SUCCESS", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                let errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.request) {
                    errorMessage = "No se recibió respuesta del servidor";
                } else {
                    errorMessage = error.message;
                }
                dispatch({ type: 'TABLERO_RESUMEN_ERROR', payload: { error: errorMessage } });
            });
    }
}

export const getTableroDetalle = (sucursal, type, fecha = null) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_DETALLE_LOADING" });
        var params = { sucursal, type };
        if (fecha) params.fecha = fecha;
        var parameters = JSON.stringify(params);

        http.post(vRutaTablero + 'obtenerdetalle.php', parameters, vHeader)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_DETALLE_SUCCESS", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                let errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.request) {
                    errorMessage = "No se recibió respuesta del servidor";
                } else {
                    errorMessage = error.message;
                }
                dispatch({ type: 'TABLERO_DETALLE_ERROR', payload: { error: errorMessage } });
            });
    }
}

export const limpiarDetalle = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_DETALLE_LIMPIAR" });
    }
}

export const getTableroGuiasReparto = (sucursal, folioReparto) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_GUIAS_REPARTO_LOADING" });
        var parameters = JSON.stringify({ sucursal, folio_reparto: folioReparto });

        http.post(vRutaTablero + 'obtenerguiasreparto.php', parameters, vHeader)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_GUIAS_REPARTO_SUCCESS", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                let errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.request) {
                    errorMessage = "No se recibió respuesta del servidor";
                } else {
                    errorMessage = error.message;
                }
                dispatch({ type: 'TABLERO_GUIAS_REPARTO_ERROR', payload: { error: errorMessage } });
            });
    }
}

export const limpiarGuiasReparto = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_GUIAS_REPARTO_LIMPIAR" });
    }
}

export const getTableroEficiencia = (sucursal) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_EFICIENCIA_LOADING" });
        var parameters = JSON.stringify({ sucursal });

        http.post(vRutaTablero + 'obtenereficiencia.php', parameters, vHeader)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_EFICIENCIA_SUCCESS", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                let errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.request) {
                    errorMessage = "No se recibió respuesta del servidor";
                } else {
                    errorMessage = error.message;
                }
                dispatch({ type: 'TABLERO_EFICIENCIA_ERROR', payload: { error: errorMessage } });
            });
    }
}

export const getTableroGuiasEficiencia = (sucursal, filtroEstado) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_GUIAS_EFICIENCIA_LOADING" });
        var parameters = JSON.stringify({ sucursal, filtro_estado: filtroEstado });

        http.post(vRutaTablero + 'obtenerguiaseficiencia.php', parameters, vHeader)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_GUIAS_EFICIENCIA_SUCCESS", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                let errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.request) {
                    errorMessage = "No se recibió respuesta del servidor";
                } else {
                    errorMessage = error.message;
                }
                dispatch({ type: 'TABLERO_GUIAS_EFICIENCIA_ERROR', payload: { error: errorMessage } });
            });
    }
}

export const limpiarGuiasEficiencia = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_GUIAS_EFICIENCIA_LIMPIAR" });
    }
}

export const getGuiaDetalles = (numeroGuia) => {
    return (dispatch, getState) => {
        dispatch({ type: "TABLERO_GUIA_DETALLES_LOADING" });
        var parameters = JSON.stringify({ guia: numeroGuia });

        http.post('monitoreo/guia.php', parameters, vHeader)
            .then(function (response) {
                dispatch({
                    type: "TABLERO_GUIA_DETALLES_SUCCESS", payload: {
                        data: response.data,
                    }
                });
            })
            .catch(function (error) {
                let errorMessage = "";
                if (error.response) {
                    errorMessage = error.response.data.mensaje;
                } else if (error.request) {
                    errorMessage = "No se recibió respuesta del servidor";
                } else {
                    errorMessage = error.message;
                }
                dispatch({ type: 'TABLERO_GUIA_DETALLES_ERROR', payload: { error: errorMessage } });
            });
    }
}

export const limpiarGuiaDetalles = () => {
    return (dispatch) => {
        dispatch({ type: "TABLERO_GUIA_DETALLES_LIMPIAR" });
    }
}
